(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["decor-dropdown.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"decor-field decor-field--fill\" data-module=\"decor-field\">\r\n\t<span class=\"decor-field__value js-decor-field__value\"></span>\r\n\t<select id=\"ddlLocation\" name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field_name"), env.opts.autoescape);
output += "\" class=\"hidden-field js-decor-field__input\" data-module=\"minimum-field\" data-min=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "item_min_count"), env.opts.autoescape);
output += "\" data-filter-key=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field_name"), env.opts.autoescape);
output += "\">\r\n\t\t";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "options");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("option", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\r\n\t\t\t<option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"value"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "</option>\r\n\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t</select>\r\n\t<span class=\"decor-field__decor\" data-icon=\"arrow_down\" role=\"presentation\"></span>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["error-message.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"form__error-message ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modifier"), env.opts.autoescape);
output += " js-form__message is-hidden\" data-id=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "id"), env.opts.autoescape);
output += "\">\r\n    <div class=\"form__error-message__inner\">\r\n        <div class=\"form__error-message__icon\" role=\"presentation\" data-icon=\"cross\"></div>\r\n        <div class=\"form__error-message__content\">\r\n\t        <dl class=\"accessible-definition\">\r\n\t        \t<dt>Error message</dt>\r\n\t        \t<dd>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "message"), env.opts.autoescape);
output += "</dd>\r\n\t        </dl>\r\n        </div>\r\n    </div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["loading-overlay.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
output += " class=\"loading-overlay ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modifier"), env.opts.autoescape);
output += "\">\r\n    <div class=\"loading-overlay__icon js-loading-overlay__icon\">\r\n    \t<span class=\"is-hidden--text\">The system is currently loading this new content, please wait.</span>\r\n    \t<img src=\"/images/status/loading.gif\" alt=\"Loading graphic\" role=\"presentation\" />\r\n    </div>\r\n</";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tag"), env.opts.autoescape);
output += ">";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["split-content-image.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"split-content__section js-live-preview__content-element\"";
if(runtime.contextOrFrameLookup(context, frame, "field")) {
output += " data-field=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field"), env.opts.autoescape);
output += "\" ";
;
}
output += "role=\"presentation\" data-settings='{\"replaceWithData\": true ";
if(runtime.contextOrFrameLookup(context, frame, "template_data")) {
output += ",\"templateData\":";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "template_data"), env.opts.autoescape);
;
}
output += " }'>\r\n    <aside class=\"split-content__section__inner\">\r\n        <div class=\"bleed-image\">\r\n            <span class=\"bleed-image__media\" style=\"background-image:url(";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
output += ")\"></span>\r\n        </div>\r\n    </aside>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["split-media-image.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"split-media__media js-live-preview__content-element\" role=\"presentation\" style=\"background-image: url(";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
output += ")\" ";
if(runtime.contextOrFrameLookup(context, frame, "field")) {
output += " data-field=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "field"), env.opts.autoescape);
output += "\" ";
;
}
output += "role=\"presentation\" data-settings='{\"replaceWithData\": true ";
if(runtime.contextOrFrameLookup(context, frame, "template_data")) {
output += ",\"templateData\":";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "template_data"), env.opts.autoescape);
;
}
output += " }'></div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["user-avatar.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"avatar ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modifier"), env.opts.autoescape);
output += "\">\r\n\t<img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "image"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "alt"), env.opts.autoescape);
output += "\" />\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
